'use client';

export const DiscountCodeInput = () => {
	const handleApplyDiscount = () => {
		// TODO
	};

	return (
		<div className="flex flex-col gap-2 rounded-md border bg-white p-4 shadow-sm">
			<label htmlFor="discount-code" className="text-sm font-medium text-gray-700">
				Discount code
			</label>
			<div className="flex w-full flex-wrap items-center gap-4">
				<input
					id="discount-code"
					type="text"
					placeholder="0000000"
					className=" focus:ring-theme600 focus:border-theme600 w-48 flex-1 rounded-md border px-3 py-2 text-gray-700 focus:outline-none focus:ring-2"
				/>
				<button
					onClick={handleApplyDiscount}
					className="hover:bg-theme700 focus:ring-theme600 min-w-[150px] flex-1 rounded-md bg-experiment px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-offset-1"
				>
					Apply discount code
				</button>
			</div>
		</div>
	);
};
